<template>
  <layout>
    <AdminPageHeader :header="$t('account.card.add')" />
    <div id="content" class="content">
      <b-card>
        <resource-form @saved="returnBack" @cancelled="returnBack" />
      </b-card>
    </div>
  </layout>
</template>

<script>
import { AdminPageHeader } from 'stylemix-vue-admin'
import ResourceForm from './CardForm.vue'

const resourceBase = 'cards'

export default {
  name: 'AddCard',

  components: {
    ResourceForm,
    AdminPageHeader,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
